"use client";

import { useEffect } from "react";

/**
 * Registers the service worker on every page load. The push opt-in flow
 * registers it lazily (lib/push-notifications.ts), but that is too late for
 * install: Chromium only offers its install UI (omnibox icon, Android's
 * banner and menu entry) once a service worker is registered for the origin —
 * and the browser's own promotion is the only Chromium install surface we
 * ship; iOS gets in-chat Add-to-Home-Screen guidance instead (see
 * lib/notification-optin-prompt.ts). register() is idempotent (the push
 * flow's later call is a no-op), requests no permission, and shows no UI.
 */
export function ServiceWorkerRegistrar() {
  useEffect(() => {
    if (!("serviceWorker" in navigator)) return;
    void navigator.serviceWorker.register("/sw.js").catch(() => undefined);
  }, []);

  return null;
}
